import { Controller } from 'stimulus';
const TomSelect = require('../../lib/tom_select');

export default class extends Controller {
  connect() {
    if (this.tomSelect) return;

    this.tomSelect = new TomSelect(this.element, {
      create: true,
      plugins: ['remove_button'],
      onItemAdd: () => {
        this.tomSelect.setTextboxValue('');
        this.tomSelect.refreshOptions(false);
      },
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
